export interface RequestInfo {
    url: string;
    options: { method: string; headers: Record<string, string> };
}

export interface startConfig {
    configUrl: string;
    apimSubsKey: string;
}
/**
 * Retrieves the request information for a specific configuration.
 *
 * @param configId - The ID of the configuration to load.
 * @returns - The request information for the specified configuration.
 */
export const getRequestInfo = (configId: string) => {
    const windowConfig = (window as any).__netaenv;
    const requestInfo: RequestInfo = {
        url: windowConfig.configUrl + '?' + new URLSearchParams({ configId, domain: window.location.hostname }),
        options: { method: 'GET', headers: { 'ocp-apim-subscription-key': windowConfig.apimSubsKey } }
    };

    return requestInfo;
};
/**
 * Loads a specific configuration. If the configuration cannot be loaded, it loads a fallback configuration.
 *
 * @param configId - The ID of the configuration to load.
 * @param fallbackUrl - The URL of the fallback configuration to load if the main configuration cannot be loaded.
 * @returns - The loaded configuration, or the fallback configuration if the main configuration cannot be loaded.
 */
export const loadConfigurationWithFallback = async (configId: string, fallbackUrl: string) => {
    const requestInfo = getRequestInfo(configId);
    const dynamicConfig = await fetch(requestInfo.url, { ...requestInfo.options });

    if (!dynamicConfig.ok) {
        return await fetch(fallbackUrl);
    }

    return dynamicConfig;
};
/**
 * Extracts the value from a configuration, if it exists.
 *
 * @param config - The configuration from which to extract the value.
 * @returns - The value extracted from the configuration, or the configuration itself if the value does not exist.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const extractValue = (config: any) => (config && config.data ? config.data : config);

export const startupConfig = async () => {
    const response = await fetch('./assets/environment/env.json');
    if (!response.ok) {
        throw new Error('Network error while fetching the configuration');
    }
    const config = {
        ...(await response.json()),
        contentSecurityPolicy: response.headers.get('content-security-policy')
    };
    (window as any).__netaenv = config;
    return config;
};
